import { render, staticRenderFns } from "./LanguageChangeModal.vue?vue&type=template&id=1d370686"
import script from "./LanguageChangeModal.vue?vue&type=script&lang=js"
export * from "./LanguageChangeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports